import { Award } from "lucide-react";

// Small "Certified Culinary Specialist" badge. Sizes: sm | md | lg.
// Rendered as a pill with the champagne-gold treatment used across the app.
export default function CertifiedBadge({
  size = "md",
  certificateNumber,
  showLabel = true,
  className = "",
}) {
  const sizes = {
    sm: { pad: "px-2 py-0.5", text: "text-[0.55rem]", icon: "w-2.5 h-2.5", gap: "gap-1" },
    md: { pad: "px-2.5 py-1", text: "text-[0.65rem]", icon: "w-3 h-3", gap: "gap-1.5" },
    lg: { pad: "px-3.5 py-1.5", text: "text-xs", icon: "w-3.5 h-3.5", gap: "gap-2" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <span
      className={`inline-flex items-center ${s.gap} ${s.pad} rounded-full uppercase tracking-[0.18em] font-semibold ${s.text} ${className}`}
      style={{
        background: "linear-gradient(180deg, rgba(232,207,154,0.22), rgba(200,169,106,0.06))",
        border: "1px solid rgba(232,207,154,0.55)",
        color: "#f2dfb5",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.15), 0 2px 8px rgba(200,169,106,0.18)",
      }}
      title={certificateNumber ? `Certified Culinary Specialist • ${certificateNumber}` : "Certified Culinary Specialist"}
      data-testid="certified-badge"
    >
      <Award className={s.icon} strokeWidth={1.75} />
      {showLabel && <span>Certified</span>}
      {showLabel && certificateNumber && (
        <span className="opacity-70 font-mono tracking-widest">• {certificateNumber}</span>
      )}
    </span>
  );
}
